import { render, staticRenderFns } from "./sublayout.vue?vue&type=template&id=7129aad2&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129aad2",
  null
  
)

export default component.exports